(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goat-home-v1"] && !Shopify.designMode) return;
  try {
    
  /* Cuadro amarillo rotativo: avanza solo cada data-seg segundos, se para al pasar el ratón o con el foco
     dentro, y con el botón de pausa; sin movimiento automático si el sistema pide menos movimiento. */
  if (!customElements.get('goat-hero-rot')) {
    customElements.define('goat-hero-rot', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.hero-slide')];
        if (this.slides.length < 2) return;
        this.dots = [...this.querySelectorAll('.hero-dot')];
        this.btn = this.querySelector('.hero-pause');
        this.i = 0; this.hold = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dots.forEach((d, k) => d.addEventListener('click', () => { this.go(k); this.restart(); }));
        this.btn.addEventListener('click', () => { this.paused = !this.paused; this.sync(); this.restart(); });
        const on = () => { this.hold++; }, off = () => { this.hold = Math.max(0, this.hold - 1); };
        this.addEventListener('mouseenter', on); this.addEventListener('mouseleave', off);
        this.addEventListener('focusin', on); this.addEventListener('focusout', off);
        this.sync(); this.restart();
      }
      disconnectedCallback() { clearInterval(this.t); }
      restart() {
        clearInterval(this.t);
        if (this.paused) return;
        this.t = setInterval(() => { if (!this.hold && !document.hidden) this.go((this.i + 1) % this.slides.length); }, (+this.dataset.seg || 6) * 1000);
      }
      go(k) {
        this.i = k;
        this.slides.forEach((s, j) => {
          const on = j === k;
          s.classList.toggle('is-on', on);
          s.toggleAttribute('aria-hidden', !on);
          s.querySelectorAll('a').forEach(a => on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1'));
          if (on) s.querySelectorAll('img[loading="lazy"]').forEach(img => img.loading = 'eager');
        });
        this.dots.forEach((d, j) => d.toggleAttribute('aria-current', j === k));
      }
      sync() {
        this.classList.toggle('is-paused', this.paused);
        this.btn.setAttribute('aria-label', this.paused ? this.btn.dataset.play : this.btn.dataset.pause);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
